import React, { FC, ReactNode, FormHTMLAttributes } from 'react';

// Form component wraps a form element,
//  accepts children, handles form submission, and allows customization via props.

interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  children: ReactNode; 
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  className?: string; 
}

const Form: FC<FormProps> = ({ children, onSubmit, className, ...props }) => {
  return (
    <form
      onSubmit={onSubmit}
      className={className}
      {...props}
    >
      {children}
    </form>
  );
};

export default Form;
